import React from 'react';
import { PenTool } from 'lucide-react';

const ContentCreatorPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-900 flex items-center">
          <PenTool className="h-8 w-8 mr-3 text-primary-600" />
          Content Creator
        </h1>
      </div>

      <div className="card">
        <div className="text-center py-12">
          <PenTool className="h-16 w-16 text-gray-300 mx-auto mb-4" />
          <p className="text-gray-600 text-lg">AI Content Creator coming soon...</p>
          <p className="text-gray-500 text-sm mt-2">
            This page will have AI-powered content generation for blogs, descriptions, and marketing materials.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContentCreatorPage; 